module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap-widget"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "cc-loader"
  }, [_c('div', {
    staticClass: "spinner"
  })]) : _c('div', [(!_vm.fetchError) ? _c('div', [_c('div', {
    staticClass: "timeline-legend columns"
  }, [_c('div', {
    staticClass: "user"
  }, [_vm._v("\n                    Standart user\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "admin"
  }, [_vm._v("\n                    Administrator\n                ")])]), _vm._v(" "), _c('ul', _vm._l((_vm.timeline), function(event, index) {
    return (index < _vm.nbItemToShow) ? _c('li', {
      key: event,
      class: event.role.toLowerCase()
    }, [_c('p', {
      staticClass: "timeline-date"
    }, [_c('i', {
      staticClass: "ion-ios-clock-outline"
    }), _vm._v(" " + _vm._s(_vm._f("fromnow")(event.date, 'fr')) + " " + _vm._s(_vm._f("formatDate")(event.date, 'fr', '[le] DD.MM.YYYY [à] HH:mm')) + "\n                    ")]), _vm._v(" "), _c('div', {
      staticClass: "timeline-action"
    }, [_c('strong', [_vm._v(_vm._s(_vm._f("capitalize")(event.user)))]), _vm._v("\n                        " + _vm._s(event.action) + "\n                    ")])]) : _vm._e()
  }))]) : _c('div', {
    staticClass: "alert alert-error"
  }, [_vm._v("\n            " + _vm._s(_vm.fetchError) + "\n        ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6b75a936!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/widget-timeline.vue
// module id = 224
// module chunks = 0